/* =======================================================================
   Photo Framing Upsell
   -----------------------------------------------------------------------
   Mirror of diploma-upsell.js in the opposite direction: when a customer
   adds the Diploma Framing product to their cart, pop up a soft CTA
   offering the Custom Photo Framing product.

     • "Yes, show me photo framing"  → navigate to the photo framing
                                        product page (customer configures
                                        design template / school / photos
                                        on that product's own form).
     • "No thanks"                    → dismiss.

   The popup does NOT touch the cart. The diploma framing line the
   customer just added stays put regardless of which button they click.

   Skip conditions:
     • Photo framing is already in the cart — upselling something they
       already have is pointless noise.

   No session-storage suppression: every qualifying add-to-cart shows
   the popup. Business preference — customers who dismiss and later add
   the trigger product again should see the offer again.

   Runs parallel to framing-upgrade.js and diploma-upsell.js. Each has
   its own window.* namespace and data-* attributes so they don't collide.
   ======================================================================= */

(function () {
  'use strict';

  if (!window.PhotoUpsell || !window.PhotoUpsell.config) return;
  if (!window.jQuery) return;
  var $ = window.jQuery;

  var CONFIG = window.PhotoUpsell.config;
  var TRIGGER_HANDLES = CONFIG.triggerHandles || [];
  var TRIGGER_TITLE_RE = CONFIG.triggerTitleRegex
    ? new RegExp(CONFIG.triggerTitleRegex, 'i')
    : null;
  var UPSELL_HANDLE = CONFIG.upsellHandle || 'custom-photo-framing-for-graduates';
  var UPSELL_URL    = CONFIG.upsellUrl    || '/products/custom-photo-framing-for-graduates';

  // ---------------------------------------------------------------------
  // 1. Eligibility — is the just-added line item the Diploma Framing
  //    product? /cart/add.js returns `handle` and `product_title`; we
  //    match handle first, fall back to a title regex.
  // ---------------------------------------------------------------------
  function isTriggerProduct(lineItem) {
    if (!lineItem) return false;
    if (lineItem.handle && TRIGGER_HANDLES.indexOf(lineItem.handle) !== -1) return true;
    var title = lineItem.product_title || lineItem.title || '';
    if (TRIGGER_TITLE_RE && TRIGGER_TITLE_RE.test(title)) return true;
    return false;
  }

  function cartContainsUpsellProduct(cart) {
    if (!cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].handle === UPSELL_HANDLE) return true;
    }
    return false;
  }

  // ---------------------------------------------------------------------
  // 3. Modal DOM plumbing.
  // ---------------------------------------------------------------------
  var $modal;
  var $confirmLink;
  var $headingEl;
  var $bodyEl;
  var $bundleBadge;

  function ensureModal() {
    if ($modal && $modal.length) return $modal;
    $modal = $('#PhotoUpsellModal');
    if (!$modal.length) return null;

    $confirmLink = $modal.find('[data-photo-upsell-confirm]');
    $headingEl   = $modal.find('[data-photo-upsell-heading]');
    $bodyEl      = $modal.find('[data-photo-upsell-body]');
    $bundleBadge = $modal.find('[data-photo-upsell-bundle-badge]');

    $confirmLink.attr('href', UPSELL_URL);

    $modal.on('click', '[data-photo-upsell-close]', closeModal);
    $confirmLink.on('click', function () { closeModal(); });

    $(document).on('keydown.photoUpsell', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    return $modal;
  }

  function openModal() {
    var $m = ensureModal();
    if (!$m) return;

    if (CONFIG.strings && CONFIG.strings.modalHeading) $headingEl.text(CONFIG.strings.modalHeading);
    if (CONFIG.strings && CONFIG.strings.modalBody)    $bodyEl.text(CONFIG.strings.modalBody);
    if (CONFIG.strings && CONFIG.strings.bundleBadge && $bundleBadge && $bundleBadge.length) {
      $bundleBadge.text(CONFIG.strings.bundleBadge);
    }
    if (CONFIG.strings && CONFIG.strings.confirm)      $confirmLink.text(CONFIG.strings.confirm);
    if (CONFIG.strings && CONFIG.strings.decline) {
      $modal.find('.frame-modal__decline').text(CONFIG.strings.decline);
    }

    $m.attr('aria-hidden', 'false').addClass('frame-modal--active');
    $('body').addClass('frame-modal-open');
  }

  function closeModal() {
    if (!$modal || !$modal.length) return;
    $modal.attr('aria-hidden', 'true').removeClass('frame-modal--active');
    $('body').removeClass('frame-modal-open');
  }

  // ---------------------------------------------------------------------
  // 4. Hook into add-to-cart. Listen to jQuery's global ajaxComplete for
  //    POSTs to /cart/add.js — same pattern as framing-upgrade.js and
  //    diploma-upsell.js.
  //
  //    Critical: we do NOT block or modify the cart response. The add-
  //    to-cart has already succeeded by the time this fires; we just
  //    react to it by showing the popup.
  // ---------------------------------------------------------------------
  $(document).ajaxComplete(function (event, xhr, settings) {
    if (!settings || !settings.url) return;
    if (!/\/cart\/add(\.js)?$/.test(settings.url)) return;

    var lineItem = null;
    try { lineItem = JSON.parse(xhr.responseText); }
    catch (e) { return; }
    if (!lineItem || !lineItem.id) return;

    if (!isTriggerProduct(lineItem)) return;

    // Skip if photo framing is already in the cart. Pulling the full
    // cart is the reliable way to check — the /cart/add.js response
    // only tells us about the line that was just added.
    $.ajax({ url: '/cart.js', dataType: 'json' }).done(function (cart) {
      if (cartContainsUpsellProduct(cart)) return;
      openModal();
    });
  });
})();
